import { getTenantId, getToken } from '@/utils/auth'

const urlList = [
  '/admin/v1/manage/token/create',
  '/admin/v1/manage/token/delete',
  '/admin/v1/manage/sendCaptcha',
]
const routeList = [
  '/login',
  '/404',
]
// 多租户接口是否需要做判断
export function isNeedUrlJudge(url, isTrue) {
  let isJudge = true
  urlList.forEach((item) => {
    if (item === url) {
      isJudge = false
    }
  })
  return isJudge ? isTrue : false
}
// 多租户路由是否需要判断
export function isNeedRouteJudge(url, isTrue) {
  let isJudge = true
  routeList.forEach((item) => {
    if (item === url) {
      isJudge = false
    }
  })
  return isJudge ? isTrue : false
}
// 设置window授权信息
export function setWindowAuthInfo() {
  const authInfo = {
    token: getToken(),
    tenantId: getTenantId(),
  }
  if (authInfo.token && Number(authInfo.tenantId) !== -1) {
    document.body.setAttribute('data-auth-info', JSON.stringify(authInfo))
  }
}
// 获取window授权信息
export function getWindowAuthInfo() {
  let authInfo = document.body.getAttribute('data-auth-info')
  authInfo = authInfo ? JSON.parse(authInfo) : null
  return authInfo
}
// 接口请求的时候判断当前窗口租户是否是最新的
export function getRequestJudge(url) {
  const newAuth = {
    token: getToken(),
    tenantId: getTenantId(),
  }
  const oldAuth = getWindowAuthInfo()
  return isNeedUrlJudge(url, oldAuth && newAuth && newAuth.token !== oldAuth.token && newAuth.tenantId !== oldAuth.tenantId)
}
// 路由切换的时候判断当前窗口租户是否是最新的
export function getRouteJudge(routeName) {
  const newAuth = {
    token: getToken(),
    tenantId: getTenantId(),
  }
  const oldAuth = getWindowAuthInfo()
  return isNeedRouteJudge(routeName, oldAuth && newAuth && newAuth.token !== oldAuth.token && newAuth.tenantId !== oldAuth.tenantId)
}
// 是否是最新租户并拒绝了请求，是的话设置
export function setIsReject() {
  document.body.setAttribute('data-all-option-is-reject', 1)
}
// 已经有相应的Toast提示了
export function getIsReject() {
  const isReject = document.body.getAttribute('data-all-option-is-reject')
  return isReject || false
}
